import BrandConfig from 'BrandConfig'
import CONFIG, { IS_PRODUCTION } from '../config'

const isSecure = window.location.protocol === 'https:'

const initProtocolConfig = (isSec: boolean) =>
  isSec
    ? {
        protocol: 'https',
        port: 443,
      }
    : {
        protocol: 'http',
        port: 5000,
      }
const createConnectionConfig = () => {
  const protocolConfig = initProtocolConfig(isSecure)

  return {
    REST_URL: `${protocolConfig.protocol}://${process.env.API_DOMAIN}:${protocolConfig.port}/api`,
    API_V2_REST_URL: `${protocolConfig.protocol}://${process.env.API_DOMAIN}:${protocolConfig.port}/api/v2`,
    API_IS_V2_REST_URL: `${protocolConfig.protocol}://${process.env.API_DOMAIN}:${protocolConfig.port}/api/is/v2`,
    AVTALEGIRO_URL: IS_PRODUCTION
      ? CONFIG.SERVICE.avtalegiro.PRODUCTION.URL
      : CONFIG.SERVICE.avtalegiro.TEST.URL,
    ACCOUNT_NUMBER: IS_PRODUCTION
      ? CONFIG.SERVICE.avtalegiro.PRODUCTION.NUMBER
      : CONFIG.SERVICE.avtalegiro.TEST.NUMBER,
    PARTNER_NAME: BrandConfig.PARTNER_NAME,
    PARTNER_NAME_AVTALEGIRO: BrandConfig.PARTNER_NAME_AVTALEGIRO,
  }
}

/* eslint-disable-next-line no-unused-vars */
const DEV_CONSTANTS = createConnectionConfig()

export const BUILD_CONSTANTS = Object.assign({}, DEV_CONSTANTS)
